/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".exampleCheckbox_35484817{margin:10px 0}.exampleLabel_35484817{margin:10px 0}\n"}]);
export const exampleCheckbox = "exampleCheckbox_35484817";
export const exampleLabel = "exampleLabel_35484817";